import "./footer.css";
import YritysSaloLogo from "../../assets/pics/yrityssalologo.png";

// Landing page footer
const Footer = () => {
  return (
    <div className="footer-container">
      <img src={YritysSaloLogo} alt="yrityssalologo" />
      <div className="footer-info-container">
        <div className="footer-info-grp">
          <p>Joensuunkatu 7</p>
          <p>24100 SALO</p>
          <p>+358 44 778 2142</p>
          <p>Yrityssalo@yrityssalo.fi</p>
        </div>
        <div className="footer-info-grp">
          <a href="https://toihinsaloon.fi">toihinsaloon.fi</a>
          <a href="https://investinsalo.fi">investinsalo.fi</a>
          <p>
            <nobr>Vapaat toimitilat</nobr>
          </p>
          <a href="https://visitsalo.fi">visitsalo.fi</a>
        </div>
        <div className="footer-info-grp">
          <a href="https://twitter.com">Twitter</a>
          <a href="https://linkedin.com">LindedIn</a>
          <a href="https://facebook.com">Facebook</a>
          <a href="https://instagram.com">Instagram</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
